import GET_CURRENT_USER from '../graphql/queries/GetCurrentUser';

// DEPRECATION WARNING: Local resolvers are still available in Apollo Client 3, but they are deprecated.
// https://www.apollographql.com/docs/react/local-state/local-resolvers/

export const resolvers = {
  Mutation: {
    logUserIn: (_, { acUser }, { cache }) => {
      const data = {
        currentUser: {
          id: acUser.id,
          loggedIn: true,
          firstName: acUser.firstName,
          lastName: acUser.lastName,
          roles: acUser.roles,
          __typename: 'CurrentUser',
        },
      };

      cache.writeQuery({ query: GET_CURRENT_USER, data });

      return null;
    },
  },
};
